export default {
    install(vue, options) {
        const onInstalled = (choice = {outcome: 'accepted'}) => {
            if (choice.outcome === 'accepted') {
                let height = window.screen.height,
                    width = window.screen.width,
                    top = window.screenY,
                    windowWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
                    dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen,
                    left = ((windowWidth / 2) - (width / 2)) + dualScreenLeft + 8;

                window.moveTo(left, top);
                window.resizeTo(width, height)

                vue.$impressions.sendEvent('app_install');
                localStorage.setItem('installed', 'true');

                options.router.go(0);
            } else {
                document.querySelector(`#handholding`).style.display = 'none';
                document.querySelector(`#handholding #step-1`).style.display = 'none';
                document.querySelector(`#handholding #step-2`).style.display = 'none';
                vue.$impressions.sendEvent('app_cancelled_install');
            }
        }

        const Listen = async () => {
            window.onbeforeinstallprompt = promptEvent => window.promptEvent = promptEvent;
            window.onappinstalled = () => onInstalled();
        }

        const Click = () => {
            vue.$impressions.sendEvent('app_lp_click')

            document.querySelector(`#handholding`).style.display = 'block';
            if(!window.promptEvent) {
                vue.$impressions.sendEvent('app_prompt_not_found')
                document.querySelector(`#handholding #step-1`).style.display = 'block';
                window.onblur = () => {
                    document.querySelector(`#handholding #step-1`).style.display = 'none';
                    document.querySelector(`#handholding #step-2`).style.display = 'block';
                    document.querySelector(`#handholding`).onclick = () => {
                        onInstalled( {outcome:'denied'})
                        document.querySelector(`#handholding`).onclick = null;
                    }
                    window.onblur = null;
                }
            } else {
                window.promptEvent.prompt();
                window.promptEvent.userChoice.then(onInstalled);
                document.querySelector(`#handholding #step-2`).style.display = 'block';
                vue.$impressions.sendEvent('app_prompt');
            }
        }

        const ClickWithLoading = () => {
            vue.$impressions.sendEvent('app_lp_click')
            document.querySelector(`#install-loading`).style.display = 'block';

            setTimeout(() => {
                document.querySelector(`#install-loading`).style.display = 'none';
                document.querySelector(`#handholding`).style.display = 'block';

                if (!window.promptEvent) {
                    vue.$impressions.sendEvent('app_prompt_not_found')
                    document.querySelector(`#handholding #step-1`).style.display = 'block';
                    document.querySelector(`#handholding`).onclick = () => {
                        onInstalled({outcome: 'denied'})
                        document.querySelector(`#handholding`).onclick = null;
                    }
                    window.onblur = () => {
                        document.querySelector(`#handholding #step-1`).style.display = 'none';
                        document.querySelector(`#handholding #step-2`).style.display = 'block';
                        window.onblur = null;
                    }
                } else {
                    window.promptEvent.prompt();
                    window.promptEvent.userChoice.then(onInstalled);
                    document.querySelector(`#handholding #step-2`).style.display = 'block';
                    vue.$impressions.sendEvent('app_prompt');
                }
            }, 4000);
        }

        const CheckInstall = () => localStorage.getItem('installed') !== null && localStorage.getItem('installed') === 'true';

        vue.prototype.$install = {
            Listen,
            Click,
            ClickWithLoading,
            CheckInstall,
        };
        vue.$install = {
            Listen,
            Click,
            ClickWithLoading,
            CheckInstall,
        };
    }
}